import React, { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import { UploadCloud, FileCheck, X } from 'lucide-react';

function formatSize(bytes) {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
}

export default function UploadZone({ acceptedFormats, onFileSelect, selectedFile, lang, t }) {
  const A = t.app;

  const onDrop = useCallback(files => {
    if (files && files.length > 0) onFileSelect(files[0]);
  }, [onFileSelect]);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: acceptedFormats,
    multiple: false,
  });

  const formatKeys = Object.keys(acceptedFormats || {}).join(', ');

  const removeLabel = lang === 'en' ? 'Remove file' : lang === 'fa' ? 'حذف فایل' : 'إزالة الملف';

  return (
    <div style={{ marginBottom: '4px' }}>
      <div
        {...getRootProps()}
        style={{
          border: isDragActive
            ? '2px solid #e94560'
            : selectedFile
              ? '2px solid #00d4aa'
              : '2px dashed rgba(233,69,96,0.35)',
          borderRadius: '14px',
          padding: '40px 24px',
          textAlign: 'center',
          cursor: 'pointer',
          background: isDragActive
            ? 'rgba(233,69,96,0.06)'
            : selectedFile
              ? 'rgba(0,212,170,0.05)'
              : '#13131f',
          transition: 'all 0.25s ease',
          transform: isDragActive ? 'scale(1.02)' : 'scale(1)',
          outline: 'none',
        }}
      >
        <input {...getInputProps()} accept={Object.keys(acceptedFormats || {}).join(',')} />

        {selectedFile ? (
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px' }}>
            <FileCheck size={44} color="#00d4aa" />
            <p style={{ fontWeight: 700, fontSize: '16px', color: '#00d4aa' }}>{selectedFile.name}</p>
            <p style={{ color: '#6b7280', fontSize: '13px' }}>{formatSize(selectedFile.size)}</p>
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '12px' }}>
            <UploadCloud size={52} color={isDragActive ? '#e94560' : '#4b5563'} />
            <p style={{ fontSize: '16px', color: isDragActive ? '#e94560' : '#9ca3af', fontWeight: 500 }}>
              {A.dropHere}
            </p>
            <p style={{ fontSize: '12px', color: '#6b7280' }}>
              {A.accepted}: <span style={{ color: '#9ca3af' }}>{formatKeys}</span>
            </p>
          </div>
        )}
      </div>

      {selectedFile && (
        <button
          onClick={e => { e.stopPropagation(); onFileSelect(null); }}
          style={{
            marginTop: '8px', background: 'none', border: 'none',
            color: '#6b7280', cursor: 'pointer', fontSize: '12px',
            display: 'flex', alignItems: 'center', gap: '4px', padding: '4px 0',
          }}
        >
          <X size={13} /> {removeLabel}
        </button>
      )}
    </div>
  );
}
